import { render, staticRenderFns } from "./PosterBg.vue?vue&type=template&id=3ab1624c&scoped=true&"
import script from "./PosterBg.vue?vue&type=script&lang=js&"
export * from "./PosterBg.vue?vue&type=script&lang=js&"
import style0 from "./PosterBg.vue?vue&type=style&index=0&id=3ab1624c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab1624c",
  null
  
)

export default component.exports